/**
 * Metody, o które trzeba poprosić jawnie - backend nie wystawia ich sam.
 * `saved_method` pojawi się tylko wtedy, gdy klient ma aktywny mandat u tego wystawcy.
 *
 * UWAGA: w koszyku lista metod przychodzi z kroku `checkout` w sendBasket, a nie
 * z POST /payment/methods. Wysyłamy tam to samo pole - jeśli backend jeszcze go nie
 * obsługuje, metoda po prostu się nie pojawi. Gdyby krok checkout zaczął odrzucać
 * nieznane pole, wystarczy ustawić tu pustą tablicę.
 */
export const ACCEPTED_METHODS: string[] = ['saved_method']

/**
 * Obciążenie zapisanej metody kartą wraca od razu, ale zapisany alias BLIK
 * potrafi czekać na bank nawet 72 h. Nie trzymamy klienta w spinnerze - po tym
 * czasie oddajemy wynik `pending` i dalej pyta ekran statusu.
 */
export const SAVED_METHOD_POLL_TIMEOUT = 30_000

/**
 * Klucz w sessionStorage: dokąd wrócić z ekranu /payment/status po bramce / 3DS.
 * Ustawiają go dodanie metody w Koncie oraz płatności za faktury (components/Payments z `returnPath`),
 * czyta i czyści PaymentStatus. Obsługa: payments/returnPath.ts.
 */
export const PAYMENT_RETURN_KEY = 'payments.returnTo'
